import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { useLoad } from '../../collection/Hooks';
import { BsFormControl, BsFormSelect, BsModalForm } from '../../collection/bootstrap/BootstrapComponents';
import Loading from '../../collection/icons/Loading';
import { apiForm, apiGet } from '../../utils/api';

export default function PrendaModal(props) {
    const isNew = props.idPrenda < 1;

    const updateData = async () => await apiGet("prendas/get/" + props.idPrenda);

    const checkData = formData => {
        let errors = {};
        // Nombre
        const name = formData.get("name");
        if (!name) {
            errors["name"] = "Campo obligatorio";
        }
        // Grupo tallas
        const grupoTallas = formData.get("grupoTallas");
        if (!grupoTallas) {
            errors["grupoTallas"] = "Campo obligatorio";
        }
        return errors;
    }

    const saveData = async data => {
        const action = isNew ? "new" : "edit";
        const result = await apiForm("prendas/" + action, data);
        if (result) {
            props.onHide();
        }
    }

    return (
        <BsModalForm
            isNew={isNew}
            onUpdate={updateData}
            onCheck={checkData}
            onSave={saveData}
            modalTitle={isNew ? "Nueva prenda" : "Editar prenda"}
            show={props.show}
            onHide={props.onHide}
            saveOnEnter>
            <PrendaForm />
        </BsModalForm>
    );
}

function PrendaForm(props) {
    const data = props.data;
    const errors = props.errors;
    const [gruposTallasList, reload] = useLoad(async () => { return await apiGet("prendas/gruposTallasList") });
    return gruposTallasList ? <>
        <BsFormControl
            /* Nombre */
            label="Nombre" name="name"
            value={data.name} error={errors.name}
            maxLength="50" />
        <BsFormSelect
            /* Grupo Tallas */
            label="Grupo Tallas" name="grupoTallas" className="mt-3"
            value={data.grupoTallas} error={errors.grupoTallas}
            options={gruposTallasList} />
        { /* EPI */}
        <Row
            className="mt-3">
            <Col sm={4}>EPI</Col>
            <Col sm={8}>
                <Form.Check
                    name="epi" value="true"
                    defaultChecked={data.epi}
                    type="switch" id="epi" />
            </Col>
        </Row>
    </> : <Loading />;
}
